<template>
  <div>

    <div class="card border-0 shadow-sm mb-3 table-responsive">
      <table class="table table-hover mb-0" v-if="cart && cart.count>0">
        <thead class="thead-light">
          <tr>
            <th style="min-width:250px">Product</th>
            <th class="text-right" style="width:150px">Quantity</th>
            <th class="text-right" :style="'width:' + (canOverrideSellingPrice ? 140 : 120) + 'px'">Price</th>
            <th class="text-right" style="width:120px">Total</th>
            <th style="width:65px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, k) in cart.products" :key="k" :id="'cart-product-' + item.key">
            <td>
              <p class="mb-0">
                <a target="_blank" :href="websiteUrl + item.listing.url"><strong>{{ item.listing.name }}</strong></a>
                <span class="small text-muted">({{ item.listing.store_based_id }}) - {{ item.listing.stock_status.text }}</span>
              </p>
              <p class="mb-0" style="margin-top:1px" v-if="item.variant && item.variant.sku">
                <span class="text-muted">SKU:</span> {{ item.variant.sku }}
              </p>
              <p class="mb-0" style="margin-top:1px" v-if="item.variant && item.variant.name">
                <span class="text-muted">Option:</span> {{ item.variant.name }}
              </p>
              <p v-if="item.listing.stock_status.code !== 'in_stock'" class="mb-0" style="margin-top:1px">
                <span class="text-danger">Expected Date:</span> {{ item.details.expected_date | formatDate }}
              </p>
              <p v-if="item.shipping_method" class="mb-0" style="margin-top:1px">
                <span class="text-muted">Shipping:</span>
                {{ item.shipping_method.name }}
                <a href="#" @click.prevent="removeShippingMethod(item)" :class="'ml-2 ' + (processing_remove_shipping_method ? 'disabled' : '')">
                  <i class="fas fa-circle-notch fa-spin" v-if="processing_remove_shipping_method"></i>
                  <i class="fa fa-edit" v-if="!processing_remove_shipping_method"></i>
                  Change
                </a>
              </p>
              <p v-if="item.product_units" class="mb-0 d-none" style="margin-top:1px">
                <span class="text-muted">Product Units:</span>
                <span v-for="(product_unit, k) in item.product_units" :key="k" class="badge badge-primary">{{ product_unit.quantity }} x {{ product_unit.barcode }}</span>
              </p>
              <div v-if="!item.shipping_method && item.shipping_methods">
                <div class="text-danger font-weight-bold">Please select the shipping method</div>
                <div class="input-group" style="max-width:300px">
                  <select name="shipping_method" class="form-control border-danger" @change="updateShippingMethod(item, $event)" :id="'shipping-method-'+item.key">
                    <option value=""></option>
                    <option v-for="(shipping_method,k) in item.shipping_methods" :value="shipping_method.id" :key="k">{{ shipping_method.name }}</option>
                  </select>
                  <div v-if="processing_remove_shipping_method || processing_shipping_method" class="input-group-append">
                    <button type="button" class="btn btn-outline-danger">
                      <i class="fas fa-circle-notch fa-spin" v-if="processing_remove_shipping_method || processing_shipping_method"></i>
                    </button>
                  </div>
                </div>
              </div>
              <p v-if="item.product_units" class="mb-0" style="margin-top:1px">
                <span class="text-muted">Product Units:</span>
                <button v-for="(product_unit, k) in item.product_units" :key="k" type="button" class="btn btn-primary btn-sm mr-1">
                  {{ product_unit.barcode }} <span class="badge badge-light">{{ product_unit.quantity }}</span>
                </button>
              </p>
            </td>
            <td class="text-right">
              <template v-if="item.product_units">{{ item.quantity }}</template>
              <div v-else class="input-group mb-3">
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-outline-secondary" @click.prevent="decreaseQuantity(item)" :disabled="processing_quantity">
                    <i class="fa fa-minus"></i>
                  </button>
                </div>
                <input type="text" class="form-control text-center" :id="item.key" :value="item.quantity" @input="updateQuantity" :disabled="processing_quantity">
                <div class="input-group-append">
                  <button type="button" class="btn btn-outline-secondary" @click.prevent="increaseQuantity(item)" :disabled="processing_quantity">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </td>
            <td class="text-right">
              <selling-price :cart_id="cart.id" :item="item" :can-override-selling-price="canOverrideSellingPrice" />
              <line-item-discounts v-if="item.line_item_discounts && !!item.line_item_discounts.length" :line_item_discounts="item.line_item_discounts" />
            </td>
            <td class="text-right">
              <div v-if="item.regular_price" class="small text-muted text-line-through">{{ item.regular_price * item.quantity | numberToRs }}</div>
              {{ item.sub_total | numberToRs }}
            </td>
            <td>
              <button type="button" class="btn btn-block btn-outline-danger" @click.prevent="removeProduct(item)" :disabled="processing_remove">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_remove"></i>
                <i class="fa fa-trash" v-if="!processing_remove"></i>
              </button>
              <!--<button type="button" class="btn btn-block btn-outline-primary mt-3" @click.prevent="removeShippingMethod(item)" :disabled="processing_remove_shipping_method || processing_shipping_method">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_remove_shipping_method || processing_shipping_method"></i>
                <i class="fas fa-truck" v-if="!processing_remove_shipping_method && !processing_shipping_method"></i>
              </button>-->
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td><span class="text-muted">Products:</span> {{ cart.products.length }}</td>
            <td><span class="text-muted">Quantities:</span> {{ cart.count }}</td>
            <td class="text-right">Sub-Total</td>
            <td class="text-right">{{ cart.sub_total | numberToRs }}</td>
            <td></td>
          </tr>
          <tr v-for="(total, k) in cart.totals" :key="k">
            <td colspan="3" class="text-right">
              {{ total.name }}
              <p v-if="total.description" class="small text-muted mb-0">{{ total.description }}</p>
            </td>
            <td class="text-right">{{ total.amount | numberToRs }}</td>
            <td>
              <button v-if="total.is_editable" @click.prevent="removeTotal(total)" type="button" class="btn btn-outline-danger" :disabled="processing_remove_total">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_remove_total"></i>
                <i class="fa fa-times" v-if="!processing_remove_total"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-outline-primary" @click.prevent="promptAdjustments">
                <i class="fas fa-percentage"></i> Add Adjustments
              </button>
            </td>
            <td class="text-right align-middle">Total</td>
            <td class="text-right align-middle">{{ cart.total | numberToRs }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <div v-else class="text-center p-4 text-muted">
        <div class="card-body">
          <i class="fas fa-shopping-cart mr-2"></i> No items are in the cart
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'
import _ from 'lodash'
import SellingPrice from './cart/SellingPrice'
import LineItemDiscounts from './cart/LineItemDiscounts'

export default {
  name: 'SaleCart',
  props: [
    'cart'
  ],
  components: {
    SellingPrice,
    LineItemDiscounts
  },
  data () {
    return {
      processing_remove: false,
      processing_remove_shipping_method: false,
      processing_remove_total: false,
      processing_shipping_method: false,
      processing_quantity: false,
      processing_price: false
    }
  },
  computed: {
    websiteUrl () {
      return this.$store.state.store ? this.$store.state.store.urls.website : '#'
    },
    canOverrideSellingPrice () {
      return this.$store.state.posSettings &&
        this.$store.state.posSettings.override &&
        this.$store.state.posSettings.override.product_selling_price
        ? this.$store.state.posSettings.override.product_selling_price
        : false
    }
  },
  methods: {
    decreaseQuantity: function (item) {
      let qtyElement = jQuery('#' + item.key)
      let qty = parseInt(qtyElement.val())
      if (qty === 1) {
        return false
      }
      qtyElement.val(qty - 1)
      qtyElement[0].dispatchEvent(new CustomEvent('input'))
    },

    increaseQuantity: function (item) {
      let qtyElement = jQuery('#' + item.key)
      let qty = parseInt(qtyElement.val())
      qtyElement.val(qty + 1)
      qtyElement[0].dispatchEvent(new CustomEvent('input'))
    },

    updateQuantity: _.debounce(function (e) {
      this.processing_quantity = true

      axios.patch('/cart/' + this.cart.id + '/products/' + e.target.id, {
        quantity: e.target.value,
        include_cart: true
      }).then((response) => {
        this.$parent.cart = response.data.data.cart
      }).catch(error => {
        this.$toast.error('Failed to update the product. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing_quantity = false
      })
    }, 500),

    updateShippingMethod: function (item, event) {
      if (!event.target.value) {
        return this.$toast.error('Please select a shipping method.')
      }

      this.processing_shipping_method = true

      axios.put('/cart/' + this.cart.id + '/products/' + item.key + '/shipping_methods', {
        id: event.target.value,
        include_cart: true
      }).then((response) => {
        this.$parent.cart = response.data.data.cart
        this.$parent.fetchPaymentMethods()
      }).catch(error => {
        this.$toast.error('Failed to update the shipping method.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing_shipping_method = false
      })
    },

    removeShippingMethod: function (item) {
      this.processing_remove_shipping_method = true

      axios.delete('/cart/' + this.cart.id + '/products/' + item.key + '/shipping_methods').then((response) => {
        this.$parent.fetchCart()
      }).catch(error => {
        this.$toast.error('Failed to remove the shipping method.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        setTimeout(() => {
          this.processing_remove_shipping_method = false
        }, 500)
      })
    },

    removeProduct (item) {
      this.processing_remove = true
      axios.delete('/cart/' + this.cart.id + '/products/' + item.key).then((response) => {
        this.$parent.fetchCart()
      }).catch(error => {
        this.$toast.error('Failed to remove the product. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing_remove = false
      })
    },

    removeTotal (total) {
      this.processing_remove_total = true
      axios.delete(process.env.URLS_POS_API + '/cart/' + this.cart.id + '/totals/' + total.id).then((response) => {
        this.$parent.fetchCart()
      }).catch(error => {
        this.$toast.error('Failed to remove the total. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing_remove_total = false
      })
    },

    promptAdjustments () {
      jQuery('#modal-add-adjustment').modal('show')
    }
  }
}
</script>

<style scoped>
  table th:first-child,
  table td:first-child {
    padding-left: 20px;
  }
  table th:last-child,
  table td:last-child {
    padding-right: 20px;
  }
  table tfoot td {
    border-color: #eee;
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/Cart.vue